// extracted by mini-css-extract-plugin
export default {"creditsPillContainer":"N_Er0UVQvFqFwtEoziGo","premium":"BWG75JiwnrePnBQVFkiW"};